import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Question from "@/components/ques/Question";
export default {
  name: "TestAnalysis",
  components: {
    Question: Question
  },
  props: {
    reportType: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      checked: true,
      id: this.$route.params.id,
      //报告id
      testInfo: {},
      //试卷详情
      report_list: [],
      //报告list
      testInfoList: [{
        id: "nickname",
        label: "考生",
        value: "",
        unit: ""
      }, {
        id: "answer_time",
        label: "用时",
        value: "",
        unit: ""
      }, {
        id: "is_pass",
        label: "考试结果",
        value: "",
        unit: ""
      }, {
        id: "sum_score",
        label: "试卷总分",
        value: "",
        unit: "分"
      }, {
        id: "user_score",
        label: "客观题得分",
        value: "",
        unit: "分"
      }, {
        id: "subjective_score",
        label: "主观题得分",
        value: "",
        unit: "分"
      }, {
        id: "submit_time",
        label: "交卷时间",
        value: "",
        unit: ""
      }],
      list: [],
      //题目列表
      visible: false,
      questionType: "",
      answer: {},
      fixed: false,
      fixedRight: 0,
      scantron: {
        list: []
      },
      //右侧答题卡列表
      section: {},
      showQuestion: {},
      ids: [],
      scrollbarWrap: null
    };
  },
  watch: {
    $route: function () {
      var _$route = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var id;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:
                id = this.$route.params.id;
                this.id = id;
                _context.next = 6;
                return this.initData(id);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function $route() {
        return _$route.apply(this, arguments);
      }

      return $route;
    }()
  },
  computed: {
    hasSection: function hasSection() {
      if (this.scantron.data.length == 0) {
        return false;
      }

      return !!this.scantron.data[0].child;
    },
    questionList: function questionList() {
      if (this.checked) {
        return this.list.filter(function (item) {
          return item.status == 2 || item.status == 4;
        });
      }

      return this.list;
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.initData(this.id);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.scrollbarWrap = _this.$refs.scroll.$el.querySelector(".el-scrollbar__wrap");

      _this.scrollbarWrap.addEventListener("scroll", _this.showContent);

      document.addEventListener("scroll", _this.setFixed);
      document.addEventListener("resize", _this.setFixed);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.scrollbarWrap.removeEventListener("scroll", this.showContent);
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    //获取页面值信息，处理数据
    initData: function () {
      var _initData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(id) {
        var _this2 = this;

        var data, newData, i, newList, j, parent_id;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$http.get("/api/app/testDetail/report/".concat(id));

              case 2:
                data = _context4.sent;
                data.report_info.answer_time = this.$actionTool.timeMeter(data.report_info.answer_time, 3);
                data.report_info.submit_time = this.$actionTool.ts(data.report_info.submit_time, "yearminute"); //报告列表

                this.report_list = data.report_list.map(function (item) {
                  return _objectSpread({}, item, {
                    submit_time: _this2.$actionTool.ts(item.submit_time, "yearminute")
                  });
                }); //试卷信息

                this.testInfo = data.report_info || {};
                this.testInfoList.forEach(function (i) {
                  i.value = data.report_info[i.id];
                  i.unit = data.report_info[i.id] == "-" ? "" : i.unit; //主观题

                  if (i.id == "subjective_score") {
                    //需要批阅
                    if (_this2.testInfo.audit == "1") {
                      i.label = "主观题得分";
                    } else {
                      //不需要批阅
                      i.label = "主观题总分";
                      i.value = data.report_info.subject_sum_score;
                      i.unit = "分";
                    }
                  }

                  if (i.id == "is_pass") {
                    //已批阅或者已提交(不需要人工批阅就是已提交)的时候
                    if (data.report_info.test_status == 1 || data.report_info.test_status == 3) {
                      i.value = data.report_info.is_pass == 1 ? "已通过" : "未通过";
                      i.type = data.report_info.is_pass;
                    } else {
                      i.value = "-";
                    }
                  }
                }); //右侧答题卡信息

                this.scantron.data = data.card_info; //数据处理
                //题目list

                newData = [];

                for (i = 0; i < data.question.length; i++) {
                  if (data.question[i].children && data.question[i].children.length > 0) {
                    newList = data.question[i].children;

                    for (j = 0; j < newList.length; j++) {
                      newData.push(_objectSpread({}, newList[j], {
                        parent_ques_stem: data.question[i].ques_stem
                      }));
                    }
                  } else {
                    newData.push(data.question[i]);
                  }
                }

                parent_id = "";
                console.log(data);
                newData.forEach(function (ques, index) {
                  if (ques.parent_id != parent_id) {
                    parent_id = ques.parent_id;
                    ques.is_sub_first = true;

                    if (index > 0) {
                      newData[index - 1].is_sub_last = true;
                    }
                  }

                  ques.ques_type = ques.question_type;
                  ques.question_id = ques.id;
                  ques.index = index + 1;

                  if (ques.ques_type != 5 && typeof ques.ques_option === "string") {
                    ques.ques_option = JSON.parse(ques.ques_option);
                  }

                  if (ques.ques_type == 1 || ques.ques_type == 2) {
                    var _id = ques.ques_option.filter(function (o) {
                      return o.is_right == 1;
                    })[0].id;

                    _this2.$set(_this2.answer, ques.question_id, _id);
                  } else if (ques.ques_type == 3 || ques.ques_type == 4) {
                    var ids = [];
                    ques.ques_option.filter(function (o) {
                      return o.is_right == 1;
                    }).forEach(function (o) {
                      ids.push(o.id);
                    });

                    _this2.$set(_this2.answer, ques.question_id, ids);
                  } else if (ques.ques_type == 7) {
                    _this2.$set(_this2.answer, ques.question_id, ques.right_answer.map(function (item) {
                      return Array.isArray(item) ? item.join("、") : item;
                    }));
                  }

                  _this2.$set(_this2.showQuestion, ques.index, true);

                  _this2.ids.push(ques.index);
                });
                this.scantron.data.forEach(function (t) {
                  if (!t.child) {
                    return;
                  }

                  t.child.forEach(function (ques, index) {
                    if (index == 0) {
                      _this2.$set(_this2.section, ques.sort, {
                        name: t.name,
                        introduce: t.introduce
                      });
                    }

                    ques.onlyError = ques.status == 2 || ques.status == 4;
                  });
                  t.onlyErrorCount = t.child.filter(function (q) {
                    return q.onlyError;
                  }).length;
                });
                this.list = newData || [];
                this.$nextTick(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee3() {
                  var size, count, _loop, _i;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this2.showContent();

                          size = 20;
                          count = parseInt(_this2.ids.length / size);

                          if (_this2.ids.length % size > 0) {
                            count++;
                          }

                          _loop = function _loop(_i) {
                            var showIds = _this2.ids.slice(_i * size, (_i + 1) * size);

                            setTimeout(function () {
                              window.MathJax.typesetPromise(showIds.map(function (id) {
                                return ".question-" + id;
                              }));
                            }, 10);
                          };

                          for (_i = 0; _i < count; _i++) {
                            _loop(_i);
                          }

                        case 6:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initData(_x) {
        return _initData.apply(this, arguments);
      }

      return initData;
    }(),
    //筛选
    handleCommand: function handleCommand(id) {
      this.$router.push({
        name: "TestAnalysis",
        params: {
          id: id
        }
      });
    },
    showContent: function () {
      var _showContent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var $, placeholderOffset, height, showId, i, id;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                $ = window.$;
                placeholderOffset = $(this.$refs.placeholder).offset();
                height = this.$refs.scroll.$el.offsetHeight;

                if (!(placeholderOffset.top - 118 - 10 > height)) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return");

              case 5:
                i = 0;

              case 6:
                if (!(i < this.ids.length)) {
                  _context5.next = 14;
                  break;
                }

                id = this.ids[i];

                if (this.showQuestion[id]) {
                  _context5.next = 11;
                  break;
                }

                showId = id;
                return _context5.abrupt("break", 14);

              case 11:
                i++;
                _context5.next = 6;
                break;

              case 14:
                if (!showId) {
                  _context5.next = 21;
                  break;
                }

                this.showQuestion[showId] = true;
                _context5.next = 18;
                return this.$nextTick();

              case 18:
                _context5.next = 20;
                return window.MathJax.typesetPromise([".question-" + showId]);

              case 20:
                this.showContent();

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function showContent() {
        return _showContent.apply(this, arguments);
      }

      return showContent;
    }(),
    setFixed: function setFixed() {
      var $ = window.$;

      if ($(window).scrollTop() + 84 > 203) {
        this.fixed = true;
        this.fixedRight = ($(window).width() - 1200) / 2;

        if (this.fixedRight < 0) {
          this.fixedRight = 0;
        }
      } else {
        this.fixed = false;
      }
    },
    scrollTo: function () {
      var _scrollTo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(id, quesInfo) {
        var data, $, top, ids, i;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                //判断当前题目有没有展示，没有展示，就不定位
                data = this.questionList.find(function (item) {
                  return quesInfo.question_id == item.question_id;
                });

                if (data) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                if (this.showQuestion[id]) {
                  _context7.next = 9;
                  break;
                }

                this.showQuestion[id] = true;
                _context7.next = 7;
                return this.$nextTick();

              case 7:
                _context7.next = 9;
                return window.MathJax.typesetPromise([".question-" + id]);

              case 9:
                $ = window.$;
                top = $("#" + id).offset().top + $(this.scrollbarWrap).scrollTop() - 118;
                $(this.scrollbarWrap).scrollTop(top);
                ids = [];
                i = 1;

              case 14:
                if (!(i < id)) {
                  _context7.next = 22;
                  break;
                }

                if (!this.showQuestion[i]) {
                  _context7.next = 17;
                  break;
                }

                return _context7.abrupt("continue", 19);

              case 17:
                this.showQuestion[i] = true;
                ids.push(i);

              case 19:
                i++;
                _context7.next = 14;
                break;

              case 22:
                _context7.next = 24;
                return this.$nextTick();

              case 24:
                ids.forEach(function (i) {
                  setTimeout(
                  /*#__PURE__*/
                  _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee6() {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return window.MathJax.typesetPromise([".question-" + i]);

                          case 2:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  })), 1);
                });

              case 25:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function scrollTo(_x2, _x3) {
        return _scrollTo.apply(this, arguments);
      }

      return scrollTo;
    }(),
    goRepeat: function () {
      var _goRepeat = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.$router.go(-1);

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function goRepeat() {
        return _goRepeat.apply(this, arguments);
      }

      return goRepeat;
    }()
  }
};